module.exports = __webpack_public_path__ + "static/media/Robo3T.6b36ac0e.png";